<script setup lang="ts">
    import { computed, ComputedRef, PropType, watch } from 'vue';
    const props = defineProps({
        title: { type: String, required: true },
        options: { type: Array as PropType<string[]>, required: true },
        showSelectedCount: { type: Boolean, default: true },
        disabled: Boolean
    });

    const selectedOptions = defineModel({
        type: Array as PropType<string[]>,
        default: () => [],
        required: false
    });

    watch(() => props.options, () => {
        selectedOptions.value = selectedOptions.value.filter(selected => props.options.includes(selected));
    });

    function selectAll(): void {
        selectedOptions.value = [...props.options];
    }

    function deselectAll(): void {
        selectedOptions.value = [];
    }

    const buttonText: ComputedRef<string> = computed(() => {
        return props.showSelectedCount
            ? `${props.title} (${selectedOptions.value?.length ?? 0})`
            : props.title;
    });
</script>

<template>
    <b-dropdown
        aria-role="list">
        <template #trigger>
            <b-button
                :label="buttonText"
                :disabled="props.disabled"
                type="is-info"
                icon-right="menu-down" />
        </template>

        <b-dropdown-item custom>
            <b-field
                position="is-centered">
                <p class="control">
                    <b-button
                        size="is-small"
                        @click="deselectAll()">
                        Clear selected
                    </b-button>
                </p>
                <p class="control">
                    <b-button
                        size="is-small"
                        @click="selectAll()">
                        Select all
                    </b-button>
                </p>
            </b-field>
        </b-dropdown-item>
        <b-dropdown-item
            v-for="option in options"
            :key="option"
            custom
            position="is-centered">
            <p class="control">
                <b-checkbox
                    v-model="selectedOptions"
                    :native-value="option">
                    {{ option }}
                </b-checkbox>
            </p>
        </b-dropdown-item>
    </b-dropdown>
</template>

<style scoped>

</style>
